if (!customElements.get('hero-image-slider')) {
  class HeroImageSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 1,
      spaceBetween: 8,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.08,
          spaceBetween: 24,
        },
      },
    };
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper || swiper.querySelectorAll('.swiper-slide').length === 1) {
        return;
      }

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('hero-image-slider', HeroImageSlider);
}
